import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-data-tables-responsive-options',
	templateUrl:'./DataTablesResponsiveOptionsPluginCompPage.html',
	styles: [],
	styleUrls:['./DataTablesResponsiveOptionsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class DataTablesResponsiveOptionsPluginCompPage
{
	mdContent_901 = `\`\`\`java
import com.jwebmp.plugins.datatable.options.responsive.DataTablesResponsiveOptions;
\`\`\``;
	mdContent_902 = `\`\`\`java
DataTablesResponsiveOptions()
\`\`\``;
	mdContent_903 = `\`\`\`java
DataTableOptions&lt;?&gt; opts = new DataTableOptions&lt;&gt;();
opts.setResponsive(new DataTablesResponsiveOptions&lt;&gt;());
\`\`\``;
}
